import React from 'react';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import { isEmpty } from 'lodash';

import { useSearch } from './search.ctx';
import InstrumentsTable from './instruments-table';

const SearchResults = () => {
  const {
    memoizedListData, isSearchLoading, selected, setSelected, shouldFetchInstruments,
    showAbrogationDate, showLastAmendmentDate, showEntryInForceDate, showAdoptionDate, showMonitoringDate, sortInfo, onSortChange
  } = useSearch();

  const shouldShowResults = shouldFetchInstruments && !isEmpty(memoizedListData);

  return (
    <Grid container>
      <Grid item xs={12}>
        {isSearchLoading && (
          <LinearProgress variant="indeterminate" color="secondary"/>
        )}
        {shouldShowResults && (
          <InstrumentsTable
            selected={selected}
            setSelected={setSelected}
            instruments={memoizedListData}
            showAdoptionDate={showAdoptionDate}
            showAbrogationDate={showAbrogationDate}
            showLastAmendmentDate={showLastAmendmentDate}
            showEntryInForceDate={showEntryInForceDate}
            showMonitoringDate={showMonitoringDate}
            sortInfo={sortInfo}
            onSortChange={onSortChange}
          />
        )}
      </Grid>
    </Grid>
  )
};

export default SearchResults;
